function stopPasting(event) {
}

document
    .querySelectorAll("[data-no-paste]")
    .forEach((element) => {
      element.onpaste = (event) => {
        event.preventDefault();
        return false;
      }
    });
